import type { CrowdexUIMessage } from '@crowdex/agent-contracts';
import type { QueuedFollowUp } from '@/lib/desktop-shell/store';

/**
 * Rebuilds the `CrowdexUIMessage` for a queued follow-up so it can be rendered
 * as an optimistic user turn or fed to the ACP content encoder. An empty text
 * body contributes no text part; attachments are appended verbatim.
 */
export function followUpUiMessage(followUp: QueuedFollowUp): CrowdexUIMessage {
  return {
    id: followUp.id,
    role: 'user',
    parts: [
      ...(followUp.message.text.length === 0
        ? []
        : [{ type: 'text' as const, text: followUp.message.text }]),
      ...followUp.message.files,
    ],
  };
}
